import React, { ChangeEvent, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import { EmailLabels, EmailObject, IUEmailLabel } from './EmailFields';
import { DeleteIcon, DropDownClickable, FieldCol } from '../styled/ContactsForm';
import { StyledFormControl } from '../styled/Inputs';
import trash from '../../core/assets/trash.png';

import { TAppContact } from 'TProtocol/common/models';

interface Props {
  contact: TAppContact;
  email: EmailObject;
  hideLabel?: boolean;
  autocomplete?: boolean;
  handleDelete: () => void;
  handleChange: (value: string) => void;
  handleLabelChange: (email: EmailObject, previousLabel: IUEmailLabel) => void;
  id?: string;
}

export default function EmailField({
  email,
  hideLabel = false,
  autocomplete = false,
  handleDelete,
  handleChange,
  handleLabelChange,
  id
}: Props) {
  const [emailAddress, setEmailAddress] = useState<string | undefined>(email.email?.displayEmail ?? '');
  const [label, setLabel] = useState<IUEmailLabel>(email.label ?? IUEmailLabel.OtherEmail);

  useEffect(() => {
    setLabel(email.label);
  }, [email.label]);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    setEmailAddress(value);
    handleChange(value);
  };

  const onLabelChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newLabel = +e.target.value as IUEmailLabel;

    setLabel(newLabel);

    handleLabelChange({
      email: email.email,
      label: newLabel
    }, label);
  };

  const options = Object.keys(IUEmailLabel)
    .filter((key) => {
      const labelOption = Number(key) as IUEmailLabel;

      if (isNaN(labelOption)) {
        return false;
      }

      return true;
    })
    .map((labelStr) => {
      const label = +labelStr as IUEmailLabel;
      return <option value={label} key={label}>{EmailLabels[label]}</option>;
    });

  return (
    <Form.Group as={Row} className="gx-2">
      <FieldCol xs={hideLabel ? 12 : 6}>
        <StyledFormControl
          autoComplete={autocomplete && (label === IUEmailLabel.PersonalEmail || hideLabel) ? 'email' : 'do-not-autocomplete'}
          name="email"
          type="email"
          id={id}
          placeholder={hideLabel ? 'Email' : EmailLabels[label]}
          value={emailAddress}
          onChange={onChange}/>
      </FieldCol>
      {
        hideLabel ? null :
          <>
            <FieldCol xs={5}>
              <DropDownClickable
                value={label}
                onChange={onLabelChange}
              >
                {options}
              </DropDownClickable>
            </FieldCol>
            <FieldCol xs={1}>
              <DeleteIcon src={trash} onClick={handleDelete}/>
            </FieldCol>

          </>
      }
    </Form.Group>
  );

}
